  $('.customer-review-slider').slick({
  slidesToShow: 1,
  dots:true,
  arrows: false,
  centerMode: true,
  autoplay:true,
  autoplaySpeed:3000
  });


   document.addEventListener('DOMContentLoaded', function () {
        function hideInvalidVariants() {
          document.querySelectorAll('.block-swatch.is-disabled').forEach(function (el) {
            el.style.display = 'none';
          });

          document.querySelectorAll('.block-swatch:not(.is-disabled)').forEach(function (el) {
            el.style.display = '';
          });
        }

        function setChecked(input) {
          if (!input) return;

          const name = input.name;

          document.querySelectorAll('input[name="' + name + '"]').forEach(function (radio) {
            radio.checked = false;
            radio.removeAttribute('checked');
          });

          input.checked = true;
          input.setAttribute('checked', 'checked');

          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.dispatchEvent(new Event('change', { bubbles: true }));

          const label = input.nextElementSibling;

          if (label && label.classList.contains('block-swatch')) {
            label.click();
          } else {
            input.click();
          }
        }

        function autoSelectAvailable() {
          const groups = document.querySelectorAll('.variant-picker__option-values');

          groups.forEach(function (group, index) {
            if (index === 0) return;

            const checked = group.querySelector('input[type="radio"][checked]');

            const validChecked =
              checked && checked.nextElementSibling && !checked.nextElementSibling.classList.contains('is-disabled');

            if (validChecked) return;

            const firstAvailable = group.querySelector('.block-swatch:not(.is-disabled)');

            if (firstAvailable) {
              const input = firstAvailable.previousElementSibling;

              if (input && input.type === 'radio') {
                setChecked(input);
              }
            }
          });
        }

        function runAll() {
          hideInvalidVariants();

          setTimeout(function () {
            hideInvalidVariants();
            autoSelectAvailable();
          }, 80);

          setTimeout(function () {
            hideInvalidVariants();
            autoSelectAvailable();
          }, 220);
        }

        runAll();

        document.body.addEventListener('click', function (e) {
          if (e.target.closest('.block-swatch')) {
            setTimeout(runAll, 70);
          }
        });
      });  